// extracted by mini-css-extract-plugin
module.exports = {"layoutWrapperMain":"styles_layoutWrapperMain__Mr2rN","root":"styles_root__2cS-e","container":"styles_container__33Coj"};